import React, { useState, useEffect, useReducer, useContext } from "react";
import { Typography, Button, Row, Col } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { fetchDataReducer } from "../../reducers/fetchDataReducer";

import UomTable from "./tables/UomTable";
import AddModal from "./modals/AddModal";
import EditModal from "./modals/EditModal";
import { useUom } from "../../hooks/useUom";
import { AccountContext } from "../../components/layouts/BaseLayout";

const { Title } = Typography;

// Use reducer here because these 3 states are all inter-connected.
const initialState = {
  refresh: true,
  loading: true,
  error: null,
};

const Uom = () => {
  const { account } = useContext(AccountContext);

  const { t } = useTranslation();
  const [state, dispatch] = useReducer(fetchDataReducer, initialState);

  const { findAll } = useUom();
  const [data, setData] = useState([]);
  const [editItem, setEditItem] = useState([]);

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (state.refresh && account.Companies) {
      findAll({
        companyId: account.Companies[0].id,
      }).then((res) => {
        if (res.status === "success") {
          setData(res.data);
          dispatch({ type: "complete" });
        } else {
          setData([]);
          dispatch({ type: "error", error: t("error.connectionError") });
        }
      });
    }
  }, [state.refresh, account.Companies, findAll, t]);

  const editRow = (item) => {
    setEditItem(item);
    setEditModal(true);
  };

  return (
    <div className="site-layout-background" style={{ padding: 24, marginTop: 16 }}>
      <Title level={2}>{t("uom.title")}</Title>

      <Row justify="space-between">
        <Col>
          <Button disabled={state.loading} type="primary" onClick={() => setAddModal(true)}>
            {t("action.add")}
          </Button>
        </Col>
        <Col>
          <Button icon={<ReloadOutlined />} disabled={state.loading} onClick={() => dispatch({ type: "refresh" })} />
        </Col>
      </Row>

      <UomTable error={state.error} loading={state.loading} dataSource={data} editRow={editRow} />

      <AddModal account={account} visible={addModal} setVisible={setAddModal} dispatch={dispatch} />

      <EditModal editItem={editItem} visible={editModal} setVisible={setEditModal} dispatch={dispatch} />
    </div>
  );
};

export default Uom;
